<template>
  <div
    @click.self="closeChallengeClone(false)"
    class="fixed top-0 left-0 w-full h-full z-[12345678900] flex items-start overflow-y-auto justify-center bg-slate-900/50 p-2.5"
  >
    <div
      class="bg-white w-full max-w-4xl rounded-2xl shadow-2xl flex flex-col min-h-[50dvh] max-h-[95dvh] overflow-hidden border border-slate-200"
    >
      <div
        class="px-4 py-2.5 border-b border-slate-100 flex items-center justify-between bg-slate-50/50"
      >
        <div class="flex items-center gap-3">
          <div class="p-2 bg-blue-100 text-blue-600 rounded-lg">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <h2 class="text-xl font-bold text-slate-800">Clone Challenge</h2>
        </div>
        <button
          @click="closeChallengeClone(false)"
          class="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <div
        class="flex-1 overflow-y-auto p-6 space-y-8"
        v-if="!uploadingChallengeClones"
      >
        <div
          class="bg-amber-50 border border-amber-200 rounded-xl p-2.5 flex gap-3 text-amber-800 text-sm"
        >
          <i class="bi bi-exclamation-triangle-fill text-lg"></i>
          <p>
            <strong>Announcement Date</strong> determines when the challenge
            becomes visible in-game. It cannot be later than the
            <strong>Start Date</strong>, but can be the same.
          </p>
        </div>

        <section class="space-y-4">
          <div class="flex items-center gap-3">
            <div class="p-1.5 bg-slate-100 text-slate-600 rounded-md">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
            <div>
              <h3
                class="text-xs font-bold text-slate-500 uppercase tracking-wider"
              >
                Single Clone
              </h3>
              <p class="text-sm text-slate-400">
                Clone for a specific date and time period
              </p>
            </div>
          </div>

          <div
            class="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 bg-slate-50 p-2.5 rounded-xl border border-slate-100"
          >
            <div class="md:col-span-2 flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700"
                >Announcement Date</label
              >
              <input
                type="datetime-local"
                v-model="announciament_date_single"
                :max="startAt"
                class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all text-sm text-black"
              />
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700"
                >Start Date & Time</label
              >
              <input
                type="datetime-local"
                v-model="startAt"
                :min="getCurrentDateTime()"
                @change="updateMinEndDate"
                class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm text-black"
              />
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700"
                >End Date & Time</label
              >
              <div class="flex gap-2">
                <input
                  type="datetime-local"
                  v-model="endAt"
                  :min="startAt"
                  @change="updateMinEndDate"
                  class="flex-1 px-3 py-2 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm text-black"
                />
                <button
                  @click="addClone"
                  class="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-full transition-colors shadow-sm shadow-blue-200 min-w-[38px] min-h-[38px] flex items-center justify-center"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section class="space-y-4">
          <div class="flex items-center gap-3">
            <div class="p-1.5 bg-slate-100 text-slate-600 rounded-md">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 2V6M16 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
                />
              </svg>
            </div>
            <div>
              <h3
                class="text-xs font-bold text-slate-500 uppercase tracking-wider"
              >
                Range Clone
              </h3>
              <p class="text-sm text-slate-400">
                Clone challenge for each date in the range
              </p>
            </div>
          </div>

          <div
            class="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 bg-slate-50 p-2.5 rounded-xl border border-slate-100"
          >
            <div class="md:col-span-2 flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700"
                >Announcement Time (Everyday)</label
              >
              <input
                type="time"
                v-model="announciament_time_ranges"
                :max="startHour_start"
                class="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm text-black"
              />
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700"
                >Start Date</label
              >
              <input
                type="date"
                :min="getCurrentDate()"
                v-model="rangesDateInterval[0]"
                class="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none text-black"
              />
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700">End Date</label>
              <input
                type="date"
                :min="rangesDateInterval[0]"
                v-model="rangesDateInterval[1]"
                class="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none text-black"
              />
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700"
                >Start Time</label
              >
              <input
                type="time"
                v-model="startHour_start"
                class="px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none text-black"
              />
            </div>
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-slate-700">End Time</label>
              <div class="flex gap-2">
                <input
                  type="time"
                  v-model="endHour_end"
                  class="flex-1 px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none text-black"
                />
                <button
                  @click="addCloneForRange"
                  class="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-full transition-colors shadow-sm min-w-[38px] min-h-[38px] flex items-center justify-center"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section
          v-if="clones.length > 0"
          class="space-y-4 pt-4 border-t border-slate-100"
        >
          <div class="flex items-center gap-3">
            <div class="p-1.5 bg-blue-50 text-blue-600 rounded-md">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17Z"
                />
              </svg>
            </div>
            <div>
              <h3
                class="text-sm font-bold text-slate-700 uppercase tracking-wider"
              >
                Ready to Clone
              </h3>
              <p class="text-sm text-slate-500">
                {{ clones.length }} challenge{{ clones.length > 1 ? "s" : "" }}
                ready to be cloned
              </p>
            </div>
          </div>

          <div
            class="grid grid-cols-1 md:grid-cols-2 gap-3 max-h-60 overflow-y-auto pr-2 custom-scrollbar"
          >
            <div
              v-for="(clone, index) in clones"
              :key="index"
              class="group flex flex-col p-3 bg-white border border-slate-200 rounded-xl hover:border-blue-300 hover:shadow-md transition-all relative"
            >
              <div class="flex items-center justify-between mb-2">
                <span
                  class="text-xs font-bold px-2 py-0.5 bg-slate-100 text-slate-500 rounded-full"
                  >#{{ index + 1 }}</span
                >
                <button
                  @click="removeClone(index)"
                  class="p-1 text-slate-300 hover:text-red-500 transition-colors"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <path d="M18 6L6 18M6 6L18 18" />
                  </svg>
                </button>
              </div>

              <div
                class="flex flex-wrap items-center gap-2 text-sm font-medium text-slate-700"
              >
                <span>{{ formatDate(clone.start_date) }}</span>
                <span class="text-slate-300 font-normal">→</span>
                <span>{{ formatDate(clone.end_date) }}</span>
              </div>

              <div
                class="mt-2 pt-2 border-t border-slate-50 flex items-center gap-2 text-[11px] text-slate-400"
              >
                <span class="font-semibold uppercase text-slate-500"
                  >Announcement:</span
                >
                <span
                  class="bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded leading-none"
                  >{{ formatDate(clone.announcement_date) }}</span
                >
              </div>
            </div>
          </div>
        </section>
      </div>

      <div
        v-else
        class="flex-1 flex flex-col items-center justify-center p-12 space-y-4"
      >
        <Loader />
        <div class="text-center">
          <p class="font-bold text-slate-700 text-lg">Creating clones</p>
          <p class="text-slate-400 text-sm">
            Please wait while we process your request.Don't close this window
            during this process.
          </p>
        </div>
      </div>

      <div
        class="px-4 py-2.5 border-t border-slate-100 bg-slate-50/50 flex items-center justify-end gap-3"
      >
        <button
          :disabled="uploadingChallengeClones"
          @click="closeChallengeClone(false)"
          class="px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-200 rounded-xl transition-colors flex items-center gap-2 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-40"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M18 6L6 18M6 6L18 18" />
          </svg>
          Cancel
        </button>
        <button
          @click="submitClones"
          :disabled="clones.length === 0 || uploadingChallengeClones"
          class="px-6 py-2 text-sm font-bold bg-blue-600 text-white rounded-xl shadow-lg shadow-blue-200 hover:bg-blue-700 disabled:bg-slate-300 disabled:shadow-none disabled:cursor-not-allowed transition-all flex items-center gap-2"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
              fill="currentColor"
            />
          </svg>
          Clone {{ clones.length }} Challenge{{ clones.length > 1 ? "s" : "" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import { postFetch } from "@/api/axiosClient";
import Loader from "../Loader.vue";

export default {
  name: "ChallengeCloneMOdal",
  props: {
    closeChallengeClone: Function,
    detail: {
      type: Object,
      required: true,
    },
  },
  components: {
    FlatPickr,
    Loader,
  },
  watch: {
    announciament_date_single(newVal) {
      if (!newVal || !this.startAt) return;

      const announcementDate = new Date(newVal);
      const startDate = new Date(this.startAt);

      if (announcementDate > startDate) {
        this.announciament_date_single = this.startAt;
      }
    },

    startAt(newVal) {
      if (!newVal || !this.announciament_date_single) return;

      const startDate = new Date(newVal);
      const announcementDate = new Date(this.announciament_date_single);

      if (announcementDate > startDate) {
        this.announciament_date_single = newVal;
      }
    },

    announciament_date_ranges(newVal) {
      if (!newVal || !this.rangeStartDateTime) return;

      const announcement = new Date(newVal);
      const rangeStart = new Date(this.rangeStartDateTime);

      if (announcement > rangeStart) {
        this.announciament_date_ranges = this.rangeStartDateTime;
      }
    },

    rangeStartDateTime(newVal) {
      if (!newVal || !this.announciament_date_ranges) return;

      const rangeStart = new Date(newVal);
      const announcement = new Date(this.announciament_date_ranges);

      if (announcement > rangeStart) {
        this.announciament_date_ranges = newVal;
      }
    },
    announciament_time_ranges(newVal) {
      if (!newVal || !this.startHour_start) return;

      if (newVal > this.startHour_start) {
        this.announciament_time_ranges = this.startHour_start;
      }
    },

    startHour_start(newVal) {
      if (!newVal || !this.announciament_time_ranges) return;

      if (this.announciament_time_ranges > newVal) {
        this.announciament_time_ranges = newVal;
      }
    },
  },

  data() {
    return {
      startAt: this.formatDate2(this.detail?.start_date || new Date()),
      endAt: this.formatDate2(this.detail?.end_date || new Date()),
      clones: [],
      announciament_date_single: this.formatDate2(
        this.detail?.announcement_date || new Date(),
      ),
      announciament_date_ranges: this.formatDate2(
        this.detail?.announcement_date || new Date(),
      ),
      announciament_time_ranges: "00:00",
      rangesDateInterval: [this.getFormattedDate(0), this.getFormattedDate(7)],
      startHour_start: this.getHourMinutes(
        this.detail?.start_time || new Date(),
      ),
      endHour_end: this.getHourMinutes(this.detail?.end_time || new Date()),
      endDateConfig: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        theme: "dark",
        minDate: this.detail.start_date || new Date(),
      },
      uploadingChallengeClones: false,
    };
  },
  computed: {
    ...mapGetters(["isMenuOpen"]),
    rangeStartDateTime() {
      if (!this.rangesDateInterval[0] || !this.startHour_start) return "";

      return `${this.rangesDateInterval[0]}T${this.startHour_start}`;
    },
  },
  methods: {
    formatDate2(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    getFormattedDate(daysToAdd) {
      const date = new Date();
      date.setDate(date.getDate() + daysToAdd);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    convertToDate(date) {
      const convertedDate = new Date(date);
      return isNaN(convertedDate) ? null : convertedDate;
    },
    formatDate(date) {
      if (!date) return "";
      const str = String(date).trim();
      const clean = str.endsWith("Z") ? str.slice(0, -1) : str;

      const [d, t] = clean.includes("T") ? clean.split("T") : clean.split(" ");

      if (!d || !t) return str;

      const [year, month, day] = d.split("-");
      const [hour, minute] = t.split(":");

      if (!year || !month || !day || !hour || !minute) return str;

      return `${day}/${month}/${year}, ${hour}:${minute}`;
    },
    getCurrentTime() {
      const now = new Date();
      return `${now.getHours()}:${now.getMinutes()}`;
    },
    getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    getHourMinutes(value) {
      if (!value) return "";

      if (typeof value === "string") {
        return value.slice(0, 5);
      }
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";

      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    updateMinEndDate() {
      this.endDateConfig.minDate = this.startAt;
    },

    checkOverlap(newStart, newEnd) {
      return this.clones.some((clone) => {
        const cloneStart = new Date(clone.start_date);
        const cloneEnd = new Date(clone.end_date);

        return newStart < cloneEnd && newEnd > cloneStart;
      });
    },
    toUTCDate(dateString) {
      if (!dateString) return null;

      const normalized = dateString.includes("T")
        ? dateString
        : dateString.replace(" ", "T") + "Z";

      return new Date(normalized);
    },
    toISOStringUTC(value) {
      if (!value) return null;

      if (value instanceof Date) {
        return value.toISOString();
      }
      if (typeof value === "string") {
        return `${value}:00.000Z`;
      }

      return null;
    },
    addClone() {
      if (!this.startAt || !this.endAt) {
        Swal.fire({
          icon: "error",
          title: "Missing Dates",
          text: "Please select both start and end dates.",
        });
        return;
      }

      const newStart = this.toUTCDate(this.startAt);
      const newEnd = this.toUTCDate(this.endAt);

      if (newStart >= newEnd) {
        Swal.fire({
          icon: "error",
          title: "Invalid Date Range",
          text: "The start date must be before the end date.",
        });
        return;
      }

      const originalStart = this.toUTCDate(this.detail.start_date);
      const originalEnd = this.toUTCDate(this.detail.end_date);

      if (
        newStart.getTime() === originalStart.getTime() &&
        newEnd.getTime() === originalEnd.getTime()
      ) {
        Swal.fire({
          icon: "error",
          title: "Duplicate Date Error",
          text: "The selected date range matches the original challenge.",
        });
        return;
      }

      if (this.checkOverlap(newStart, newEnd)) {
        Swal.fire({
          icon: "error",
          title: "Overlap Error",
          text: "The selected date range overlaps with an existing clone.",
        });
        return;
      }

      const isDuplicate = this.clones.some((clone) => {
        const cloneStart = this.toUTCDate(clone.start_date);
        const cloneEnd = this.toUTCDate(clone.end_date);
        return (
          cloneStart.getTime() === newStart.getTime() &&
          cloneEnd.getTime() === newEnd.getTime()
        );
      });

      if (isDuplicate) {
        Swal.fire({
          icon: "error",
          title: "Duplicate Clone",
          text: "A clone with the same start and end dates already exists.",
        });
        return;
      }
      this.clones.push({
        ...this.detail,

        announcement_date: this.toISOStringUTC(this.announciament_date_single),
        start_date: this.toISOStringUTC(this.startAt),
        end_date: this.toISOStringUTC(this.endAt),

        created_at: new Date().toISOString(),
        code: this.detail.code ?? 1,
      });
    },

    addCloneForRange() {
      if (!this.startHour_start || !this.endHour_end) {
        Swal.fire({
          icon: "error",
          title: "Missing Time",
          text: "Please select both start and end times.",
        });
        return;
      }

      const startDate = new Date(this.rangesDateInterval[0]);
      const endDate = new Date(this.rangesDateInterval[1]);

      if (startDate > endDate) {
        Swal.fire({
          icon: "error",
          title: "Date error",
          text: "Start must be before End!",
        });
        return;
      }

      const clonesToAdd = [];
      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split("T")[0];
        const announcementDateTime = `${formattedDate} ${this.announciament_time_ranges}`;
        let start_at = `${formattedDate} ${this.startHour_start}`;
        let end_at = `${formattedDate} ${this.endHour_end}`;

        start_at = this.toISOStringUTC(start_at);
        end_at = this.toISOStringUTC(end_at);
        clonesToAdd.push({
          ...this.detail,
          // announcement_date: this.toISOStringUTC(
          //   this.announciament_date_ranges,
          // ),
          announcement_date: this.toISOStringUTC(announcementDateTime),
          start_date: start_at,
          end_date: end_at,
          start_time: this.startHour_start,
          end_time: this.endHour_end,
          created_at: new Date()
            .toISOString()
            .replace("T", " ")
            .substring(0, 19),
          code: this.detail.code ?? 1,
        });
        currentDate.setDate(currentDate.getDate() + 1);
      }
      const newClones = clonesToAdd.filter((newClone) => {
        return !this.clones.some((existingClone) => {
          return (
            new Date(existingClone.start_date).getTime() ===
              new Date(newClone.start_date).getTime() &&
            new Date(existingClone.end_date).getTime() ===
              new Date(newClone.end_date).getTime()
          );
        });
      });

      if (newClones.length === 0) {
        Swal.fire({
          title: "No New Clones Added",
          text: "All selected dates already exist as clones.",
        });
        return;
      }

      this.clones.push(...newClones);

      Swal.fire({
        title: "Clones Created",
        text: `${newClones.length} new challenges added successfully.`,
      });
    },
    removeClone(index) {
      this.clones.splice(index, 1);
    },
    async submitClones() {
      this.uploadingChallengeClones = true;
      try {
        for (let i = 0; i < this.clones.length; i++) {
          let formData = this.clones[i];

          // console.log('FORM DATA', formData);
          // return;
          try {
            await postFetch(`campaigns`, formData);
            // await postFetch("freebets", formData);
            await new Promise((resolve) => setTimeout(resolve, 400));
          } catch (error) {
            console.error(`Error uploading clone #${i + 1}:`, error);
            Swal.fire({
              title: "Error!",
              text: `An error occurred while creating the challenge clone #${
                i + 1
              }.`,
              icon: "error",
            });
          }
        }
        await Swal.fire({
          title: "Success!",
          text: "All challenge clones have been uploaded successfully.",
        });

        window.location.href = "/challenges";
      } catch (error) {
        console.error("Error during the cloning process:", error);
        Swal.fire({
          title: "Error!",
          text: "An error occurred while creating the challenge clones. Please check the process.",
          icon: "error",
        });
      } finally {
        this.uploadingChallengeClones = false;
      }
    },
  },
  mounted() {
    import("@/assets/styles/components/flatPickerv2.scss");
    document.body.style.overflow = "hidden";
  },
  beforeUnmount() {
    document.body.style.overflow = "";
    const styleElement = document.querySelector(
      "link[href='@/assets/styles/components/flatPickerv2.scss']",
    );
    if (styleElement) {
      styleElement.remove();
    }
  },
};
</script>

<style lang="scss" scoped>
.clone-freebet-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  //   backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9876543210;
  padding: 20px;
}

.clone-freebet-modal {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  border-radius: 24px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(148, 163, 184, 0.1);
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.modal-title {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.025em;
}

.close-button {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.1);
  border: none;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-button:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.modal-content {
  padding: 1rem;
  max-height: 60vh;
  overflow-y: auto;
  gap: 1rem;
  scrollbar-color: rgba(255, 255, 255, 0.281) transparent;
}

.clone-section {
  margin-bottom: 0;
  padding: 1rem;
  background: rgba(30, 41, 59, 0.5);
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.1);
}

.section-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 0.55rem;
}

.section-icon {
  width: 20px;
  height: 20px;
  color: #10b981;
  margin-top: 2px;
}

.section-info h3 {
  color: white;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 4px 0;
  letter-spacing: 0.05em;
}

.section-info p {
  color: #94a3b8;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.date-time-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 16px;
  align-items: end;
  flex-wrap: nowrap;
  display: flex;

  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
}

.range-inputs {
  display: flex;
  flex-direction: row;
  gap: 0.65rem;
  align-items: flex-end;
  flex-wrap: nowrap;
  width: 100%;

  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
}

.date-range-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  flex: 1;
}

.time-range-group {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 16px;
  align-items: end;
  flex: 1;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  color: white;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.input-group .announciament-input {
  border: 1px solid rgba(204, 204, 204, 0.3137254902) !important;
  border-radius: 14px !important;
  background: rgb(47, 64, 91) !important;
  color: white !important;
  text-align: start !important;
  vertical-align: middle !important;
  font-size: 14px;
  margin-bottom: 0.55rem;
  padding: 12px 16px;
}

.datetime-input,
.date-input,
.time-input {
  padding: 12px 16px;
  background: rgba(30, 41, 59, 0.5);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  color: white;
  font-size: 14px;
  transition: all 0.3s ease;
  outline: none;
}

.datetime-input:focus,
.date-input:focus,
.time-input:focus {
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.05);
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.add-clone-btn {
  width: 100%;
  height: 35px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  color: white;
  max-width: 35px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);

  @media (max-width: 767px) {
    width: 100%;
    min-width: 100%;
    border-radius: 14px;
  }
}

.add-clone-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
}

.clones-list-section {
  margin-bottom: 0;
  padding: 1rem;
  background: rgba(30, 41, 59, 0.3);
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.1);
}

.clones-container {
  max-height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  scrollbar-color: #fffdfd54 transparent;
}

.clone-item {
  display: flex;
  align-items: center;
  gap: 0px;
  padding: 16px;
  background: rgba(30, 41, 59, 0.5);
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.1);
  transition: all 0.2s ease;
  flex-direction: column;
}

.clone-item:hover {
  background: rgba(16, 185, 129, 0.05);
  border-color: rgba(16, 185, 129, 0.3);
}

.clone-number {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  max-width: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clone-details {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.clone-dates {
  color: #e2e8f0;
  font-size: 14px;
  font-weight: 500;
}

.clone-separator {
  color: #10b981;
  font-weight: 600;
}

.remove-clone-btn {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  max-width: 32px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #ef4444;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.remove-clone-btn:hover {
  background: rgba(239, 68, 68, 0.2);
}

.loading-state {
  padding: 60px 32px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(16, 185, 129, 0.2);
  border-top: 3px solid #10b981;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-state p {
  color: #94a3b8;
  font-size: 16px;
  margin: 0;
}

.modal-actions {
  display: flex;
  gap: 12px;
  padding: 1rem;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
}

.cancel-btn {
  flex: 1;
  padding: 14px 20px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(148, 163, 184, 0.1);
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  background: rgba(148, 163, 184, 0.2);
  color: white;
}

.clone-btn {
  flex: 1;
  padding: 14px 20px;
  border-radius: 14px;
  border: none;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  position: relative;
  overflow: hidden;
}

.clone-btn:not(.disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
}

.clone-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .clone-freebet-modal {
    margin: 10px;
    max-width: none;
  }

  .modal-actions {
    flex-direction: column;
  }

  .modal-title {
    font-size: 20px;
  }

  .add-clone-btn {
    width: 100%;
  }
}

.warning-content {
  display: flex;
  justify-content: flex-start;
  color: #ffffff;
  line-height: 1.1;
  gap: 0.55rem;
  border: 1px solid #f7f793;
  padding: 0.85rem;
  border-radius: 14px;
  align-items: center;
  background: #00000021;
  font-size: 0.875rem;
  font-weight: 600;
}

.warning-content i {
  color: yellow;
  font-weight: 700;
}

.warning-content b {
  color: #4bdcaf;
  font-weight: 700;
}

.clone-details-container {
  width: 100%;
}

.clone-details-info {
  min-width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.clone-announcement-date {
  min-width: 100%;
  display: flex;
  color: lightgray;
  gap: 0.35rem;
  font-size: 0.875rem;
  padding-left: 40px;
  line-height: 1;
}

.clone-announcement-date .clone-dates {
  font-size: 90% !important;
}
</style>
